import type { EntradaConfiguracaoObservabilidade } from '@next/compartilhados/observabilidade/configuracao'

/** Ausência mantém o padrão; valores preenchidos diferentes de true desativam a captura. */
export const lerHabilitacaoErros = (valor: string | undefined): boolean | undefined => (
  valor === undefined || valor === '' ? undefined : valor === 'true'
)

/** O destino pertence ao build: servir uma dist de produção em localhost não o altera. */
export const configuracaoObservabilidadeDoBootstrap = (
  ambienteNode: string | undefined,
  entrada: EntradaConfiguracaoObservabilidade = {},
  controles: Readonly<{ desativado?: boolean; k8s?: boolean }> = {},
): EntradaConfiguracaoObservabilidade => {
  if (controles.desativado || entrada.habilitado === false) return { habilitado: false }
  if (controles.k8s || ambienteNode === 'development') return { ambiente: 'local' }
  if (ambienteNode === 'production' && entrada.ambiente === 'producao') return { ...entrada, habilitado: true }
  return { habilitado: false }
}
